import EventContextValueProvider from "../../Compositions/EventContextValueProvider";
import ComposableUserEventHub from "../Components/ComposableUserEventHub";
import IUserEventConsumerProps from "../Types/IUserEventConsumerProps";
import ComposedGoogleTagsUserEventConsumer from "./GoogleTagsManagerEventConsumer";

const userEventConsumers: React.FC<IUserEventConsumerProps>[] = [ComposedGoogleTagsUserEventConsumer];

const UserEventsHub: React.FC<IUserEventConsumerProps> = props =>
  ComposableUserEventHub({
    ...props,
    Consumers: userEventConsumers
  });

const ComposedUserEventsHub: React.FC = EventContextValueProvider({
  Component: UserEventsHub,
  map: ({ userEvent }) => ({ userEvent })
});

export default ComposedUserEventsHub;
